import { render, staticRenderFns } from "./TabellaDisegni.vue?vue&type=template&id=72a57084&scoped=true&"
import script from "./TabellaDisegni.vue?vue&type=script&lang=js&"
export * from "./TabellaDisegni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a57084",
  null
  
)

export default component.exports